import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

const styles = theme => ({
	contentText:{
		marginBottom:15
	}
});

function Transition(props) {
	return <Slide direction="up" {...props} />;
}


class formDialog extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			inputText : ''
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps){
		if(nextProps.open !== this.props.open){
			this.setState({
				inputText : ''
			});
		}
	}

	/** event handlers **/
	handleChange = (event) =>{
		this.setState({
			inputText : event.target.value
		});
	};

	handleClose = () =>{
		const {afterCancelFunc} = this.props;
		if(afterCancelFunc) afterCancelFunc();
	};

	handleContinue = () =>{
		const {afterContinueFunc} = this.props;
		if(afterContinueFunc) afterContinueFunc();
	};

	handleSave = () =>{
		const {canOverride, afterOkFunc} = this.props;
		if(afterOkFunc) afterOkFunc(canOverride, this.state.inputText);
	};



	render () {
		const {open, canOverride, classes} = this.props;

		const saveDisabled = !canOverride && this.state.inputText === '';
		const helperText = canOverride ? "※入力がない場合は、現在の条件が上書き保存されます" : "入力された名称で新しい条件を保存します";

		return (
			<Dialog
				open={open}
				onClose={this.handleClose}
				aria-labelledby="form-dialog-title"
				TransitionComponent={Transition}
				keepMounted
				fullWidth
				maxWidth={'sm'}
			>
				<DialogTitle id="form-dialog-title">確認</DialogTitle>
				<DialogContent>
					<DialogContentText className={classes.contentText}>
						内容が変更されています。<br/>編集中の内容を保存してから処理を続けますか？<br/>
					</DialogContentText>
					<TextField
						autoFocus
						margin="dense"
						id="conditions_name"
						label="新しい条件名"
						placeholder="別名で条件名を登録する場合、新しい条件名を入力してください。"
						fullWidth
						onChange={this.handleChange}
						helperText={helperText}
						value={this.state.inputText}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={this.handleClose} color="primary">
						キャンセル
					</Button>
					<Button onClick={this.handleContinue} color="primary">
						保存しないで続ける
					</Button>
					<Button onClick={this.handleSave} color="primary" disabled={saveDisabled}>
						保存してから続ける
					</Button>
				</DialogActions>
			</Dialog>

		);
	}
}
formDialog.propTypes = {
	open : PropTypes.bool,
	canOverride : PropTypes.bool,
	afterOkFunc : PropTypes.func,
	afterContinueFunc : PropTypes.func,
	afterCancelFunc : PropTypes.func
};
export default withStyles(styles)(formDialog);



// WEBPACK FOOTER //
// ./src/routes/statistics/components/form-dialog.js